import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const microsoftBusinessCentral = defineConnector({
  identifier: "microsoftBusinessCentral",
  name: "Microsoft Business Central",
  tagLine: "ERP for small and midsize businesses",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.businesscentral\\.dynamics\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Microsoft Business Central instance details",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the details for your Microsoft Business Central instance.",
        },
        {
          kind: "input",
          label: "Tenant ID",
          placeholder: "a1b2c3d4-e5f6-47a8-9b0c-d1234567890f",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
          helperText:
            "The unique identifier for your organization that uses Microsoft services",
        },
        {
          kind: "input",
          label: "Environment name",
          placeholder: "production",
          required: true,
          target: { kind: "configuration", field: "environmentName" },
          helperText:
            "The Business Central environment name for your organization.",
        },
      ],
    },
    {
      title: "Create a Microsoft Business Central app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Business Central service-to-service auth docs](https://learn.microsoft.com/en-us/dynamics365/business-central/dev-itpro/administration/automation-apis-using-s2s-authentication) and register a Microsoft Entra app for Business Central. Copy the client ID and client secret after you grant the app access to your environment.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://login.microsoftonline.com/${configuration.tenantId}/oauth2/v2.0/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://api.businesscentral.dynamics.com/v2.0/${configuration.tenantId}/${configuration.environmentName}/`,
  },
  publicEnvVars: ({ tenantId, environmentName }) => ({
    BUSINESS_CENTRAL_TENANT_ID: tenantId || "",
    BUSINESS_CENTRAL_ENVIRONMENT_NAME: environmentName || "",
  }),
});
